const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4000/api";

/**
 * Public (no auth): property summary + bookable slots.
 * @param {string} slug
 */
export async function getPublicShowingSchedule(slug) {
  const res = await fetch(
    `${API_BASE_URL}/public/p/${encodeURIComponent(slug)}/schedule`
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Could not load schedule");
  }
  return data;
}

/**
 * @param {string} slug
 * @param {{ name: string, phone: string, email: string, slotStart: string, slotEnd: string }} body
 */
export async function bookPublicShowing(slug, body) {
  const res = await fetch(
    `${API_BASE_URL}/public/p/${encodeURIComponent(slug)}/schedule/book`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Booking failed");
  }
  return data;
}
